export default "__VITE_ASSET__BFz$7H2m__"